import React from "react";

const NotAuthorized = () => {

  return (
    <div className="skills-Bridger">
      <div className="d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h2 className="mb-2">Not Authorized</h2>
          <p>You Are Not Authorized To Access This Page. Contact Your Admin.</p>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;